// Services
import { sortArray, sortByAttribute } from './sort';

// Interfaces
import { DrugAdministration, DrugAdministrationList } from '../interfaces/Drug';

// Other
import moment from 'moment';

// creates a DrugAdministrationList array from a DrugAdministration array.
export const createAdministrationsList = (list: DrugAdministration[]) => {

    const drugList: DrugAdministrationList[] = [];

    for (const drugAdmin of list) {
        let drugListDrug = drugList.find(item => item.drugId === drugAdmin.drug_id);
        if (!drugListDrug) {
            drugListDrug = {
                drugId: drugAdmin.drug_id || undefined,
                drugName: drugAdmin.drug?.mnemonic || '',
                observation: drugAdmin.observations ? drugAdmin.observations : null,
                administration_way: drugAdmin.administration_way || null,
                hours: {}
            };
            drugList.push(drugListDrug);
        }

        if (drugListDrug.administration_way === null && drugAdmin.administration_way)
            drugListDrug.administration_way = drugAdmin.administration_way;
        if (drugListDrug.observation === null && drugAdmin.observations)
            drugListDrug.observation = drugAdmin.observations;

        const date = moment(drugAdmin.prescription_date);
        const hourStr = date.startOf('h').format('HH:mm');
        if (!drugListDrug.hours[hourStr]) {
            drugListDrug.hours[hourStr] = {};
        }

        const dateStr = date.format('YYYY-MM-DD');
        const dateMap = drugListDrug.hours[hourStr];
        if (!dateMap[dateStr]) {
            dateMap[dateStr] = [];
        }

        dateMap[dateStr].push(drugAdmin);
    }

    return sortByAttribute(drugList, 'drugName');
};

// returns an ordered list of dates frum a DrugAdministrationList array
export const getOrderedDatesFromAdministrationList = (list: DrugAdministrationList[]) => {

    let dates: string[] = [];

    list.forEach(drug => {
        Object.keys(drug.hours).forEach(hour => {
            dates.push(...Object.keys(drug.hours[hour]));
        });
    });
    dates = Array.from(new Set(dates));

    // Ordenar fechas
    return sortArray(dates, false);
};

// computes the precentage of adherence of the pharmacy table.
export const computeColsPercentage = (drugs: DrugAdministrationList[], dates: string[]) => {
    const datesPercentages: { [date: string]: { taken: number, total: number } } = {};
    dates.forEach(date => {
        datesPercentages[date] = {
            taken: 0,
            total: 0,
        };
    });

    drugs.forEach(drug => {
        Object.keys(drug.hours).forEach(hour => {
            Object.keys(drug.hours[hour]).forEach(date => {
                datesPercentages[date].taken += drug.hours[hour][date] && drug.hours[hour][date][0].status === 'administred' ? 1 : 0;
                datesPercentages[date].total += 1;
            });
        });
    });

    return datesPercentages;
};

export const getTakenValue = (administration: DrugAdministration | undefined) => {
    if (administration === undefined || administration.status === 'no_administred') return null;
    return (administration.status === 'administred');
};

export const getNonTakenValue = (administration: DrugAdministration | undefined) => {
    if (administration === undefined || administration.status === 'cancelled') return false;
    return true;
};

export const colorCellPharmacy = (deleted: boolean | undefined, status: string | undefined) => {
    if (deleted) return 'grayCell';
    if (!status) return '';
    switch (status) {
        case 'administred': return 'greenCell';
        case 'forgotten': return 'yellowCell';
        case 'cancelled': return 'redCell';
    }
    return '';
};

export const getRescueDose = (drugAdmins: DrugAdministration[]) => {
    if (drugAdmins === undefined || drugAdmins.length === 0) return 0;
    let rescueDoses = 0;
    drugAdmins.forEach(drugAdmin => {
        if (typeof drugAdmin.rescue_dose_number === 'number') rescueDoses += drugAdmin.rescue_dose_number;
    });
    return rescueDoses;

};